import React from 'react';
import { Container } from 'reactstrap';
import TenderEval from './components/TenderEval';

const TenderEvalPage = () => {
  document.title = 'Tender Evaluation';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <TenderEval />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TenderEvalPage;
